
import { SocketIoSocketFactory } from './socketio-socket-factory';
import { DocumentViewService } from './view-services/document-view.service';
import { OnlineUsersService } from './view-services/online-users.service';

export const RealTimeServicesModule =  angular
    .module('sharebase.realTimeServices', [
        'phoenix.services'
    ])
    .service('sbrtsSocketFactory', SocketIoSocketFactory)
    .service('sbrtsDocumentViewService', DocumentViewService)
    .service('sbrtsOnlineUsersService', OnlineUsersService);

export { DocumentViewService, IDocumentViewService } from './view-services/document-view.service';
export { OnlineUsersService, IOnlineUsersService } from './view-services/online-users.service';
export * from './sockets';
export { SocketFactory } from './socket-factory';




// WEBPACK FOOTER //
// ./src/real-time/index.ts